import BaseView from '../../core/baseView';

export default BaseView.extend({
  events: {
    'keyup #reason-comment': 'validate'
  },

  $label: null,
  $textarea: null,

  initialize: function() {
    this.$label = this.$('.js-reason-comment-label');
    this.$textarea = this.$('#reason-comment');
  },

  show: function() {
    this.model.set('commentFieldVisible', true);
    this.$el.removeClass('is-hidden');
  },

  hide: function() {
    this.model.set('commentFieldVisible', false);
    this.$el.addClass('is-hidden');
  },

  updateLabel: function(commentId) {
    var id = 1;

    if (commentId) {
      id = commentId;
    }

    this.$label.text(this.model.get('translations').commentField[id]);
  },

  validate: function() {
    var bValid = true;

    if (
      this.model.get('commentFieldVisible') &&
      this.$textarea.val().length > this.model.get('maxCommentLength')
    ) {
      bValid = false;
    }

    this.model.set('commentFieldValid', bValid);

    if (bValid) {
      this.$textarea.removeClass('invalid');
    } else {
      this.$textarea.addClass('invalid');
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step2CommentView.js
 **/